import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77f09ac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "botContainer" }
const _hoisted_2 = { style: {"overflow":"auto"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  style: {"overflow":"hidden"}
}
const _hoisted_5 = {
  key: 0,
  src: "https://webchat.botframework.com/embed/ZenDeskLanguage-bot?s=XaRpeucpTn8.iXqM3Oot5lO1zDBd8YZ2-SBNI5D-jm2vZz3VakNDfME",
  class: "botConversationContainer"
}
const _hoisted_6 = {
  key: 1,
  class: "botConversationContainer"
}
const _hoisted_7 = { class: "botConversationHeader" }
const _hoisted_8 = { style: {"font-size":"18px","font-weight":"bold","margin-bottom":"-6px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "online", -1))
const _hoisted_10 = {
  key: 2,
  class: "botConversationContainer"
}
const _hoisted_11 = { class: "botConversationHeader" }
const _hoisted_12 = { style: {"font-size":"18px","font-weight":"bold","margin-bottom":"-6px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "online", -1))
const _hoisted_14 = {
  ref: "messages",
  class: "botConversationMessages",
  style: {"min-height":"30px"}
}
const _hoisted_15 = {
  key: 0,
  class: "chatMessage"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader__dot" }, "."),
  /*#__PURE__*/_createElementVNode("span", { class: "loader__dot" }, "."),
  /*#__PURE__*/_createElementVNode("span", { class: "loader__dot" }, ".")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "botConversationWrite" }
const _hoisted_20 = {
  fill: "currentColor",
  width: "18",
  height: "18",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"margin":"6px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.85 1.15c.2.2.2.5 0 .7L10.9 5.81a4.78 4.78 0 0 0-.71-.7l3.96-3.96c.2-.2.5-.2.7 0ZM4.65 6.19l-.39.36 5.2 5.2.4-.4a3.67 3.67 0 1 0-5.2-5.16ZM1.3 8.04l2.1-.95 5.52 5.52-.95 2.1a.5.5 0 0 1-.81.14l-6-6a.5.5 0 0 1 .14-.8Z",
  fill: "white"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "currentColor",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.72 1.05a.5.5 0 0 0-.71.55l1.4 4.85c.06.18.21.32.4.35l5.69.95c.27.06.27.44 0 .5l-5.69.95a.5.5 0 0 0-.4.35l-1.4 4.85a.5.5 0 0 0 .71.55l13-6.5a.5.5 0 0 0 0-.9l-13-6.5Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BotFrameworkChat = _resolveComponent("BotFrameworkChat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BotList, (bot) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{ selected: _ctx.SelectedBot===bot }, "bot"]),
          onClick: ($event: any) => (_ctx.SelectedBot=bot)
        }, [
          _createVNode(_component_Avatar, {
            UserName: bot.userName,
            Initials: bot.initials,
            Size: "small"
          }, null, 8, ["UserName", "Initials"]),
          _createTextVNode(" " + _toDisplayString(bot.name), 1)
        ], 10, _hoisted_3))
      }), 256))
    ]),
    (_ctx.SelectedBot!=null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.SelectedBot.name=='Old Bot')
            ? (_openBlock(), _createElementBlock("iframe", _hoisted_5))
            : (_ctx.SelectedBot.name=='Fluence Bot')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Avatar, {
                      UserName: _ctx.SelectedBot.userName,
                      Initials: _ctx.SelectedBot.initials,
                      Size: "large"
                    }, null, 8, ["UserName", "Initials"]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.SelectedBot.name), 1),
                      _hoisted_9
                    ])
                  ]),
                  _createVNode(_component_BotFrameworkChat)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Avatar, {
                      UserName: _ctx.SelectedBot.userName,
                      Initials: _ctx.SelectedBot.initials,
                      Size: "large"
                    }, null, 8, ["UserName", "Initials"]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.SelectedBot.name), 1),
                      _hoisted_13
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectedBot.history, (message) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        (message.message == '`~`')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([{user: message.user==true, error: message.isError==true}, "chatMessage"]),
                              innerHTML: _ctx.URLify(message.message)
                            }, null, 10, _hoisted_18))
                      ]))
                    }), 256))
                  ], 512),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      style: {"width":"30px","height":"30px","border-radius":"15px","background-color":"var(--anaplan-background)","margin-top":"6px","cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Clear && _ctx.Clear(...args)))
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "2",
                      type: "text",
                      placeholder: "Your message",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Message) = $event)),
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.SendMessage && _ctx.SendMessage(...args)), ["enter"])),
                      style: {"resize":"none"}
                    }, null, 544), [
                      [_vModelText, _ctx.Message]
                    ]),
                    _createElementVNode("div", {
                      style: {"margin-top":"6px","position":"relative","top":"9px","right":"32px","cursor":"pointer"},
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SendMessage && _ctx.SendMessage(...args)))
                    }, _hoisted_24)
                  ])
                ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}